import { createModel } from "hox";
import { useBoolean } from "ahooks";
// import { useBoolean } from 'react-use';

function useToggle(defValue) {
  const [state, { toggle, setTrue, setFalse }] = useBoolean(defValue ?? false);
  const set = bool => (bool ? setTrue : setFalse);
  return { state, toggle, set };
}

export const useSiderMenuToggleModel = createModel(useToggle);











































































































































































































































































































































































































































































